// extracted by mini-css-extract-plugin
module.exports = {"container":"PhoneInput_container__1M6OS","errorContainer":"PhoneInput_errorContainer__3JdwO","placeholder":"PhoneInput_placeholder__3t3kA","error":"PhoneInput_error__22F9D"};